if (typeof Object.hasOwn !== 'function') {
  Object.hasOwn = (target: object, property: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(target, property);
}
